import { render, staticRenderFns } from "./RecalculationErrors.vue?vue&type=template&id=2d50182c&scoped=true"
import script from "./RecalculationErrors.vue?vue&type=script&lang=ts"
export * from "./RecalculationErrors.vue?vue&type=script&lang=ts"
import style0 from "./RecalculationErrors.vue?vue&type=style&index=0&id=2d50182c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d50182c",
  null
  
)

export default component.exports